
<template>
    <div class="mb-5">
        <h1 class="page-title">FILTRE PAR CATÉGORIE</h1>
    </div>

    <div class="card">
        <DataTable
            :value="tableData"
            :rows="rows"
            :totalRecords="totalRecords"
            :currentPage="currentPage"
            :rowHover="true"
            :loading="loading"
            :rowsPerPageOptions="[10, 30, 50, 100]"
            lazy
            paginator
            template="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
            currentPageReportTemplate="Affichage de {first} à {last} sur {totalRecords} entrées"
            @page="onPaginate($event)"
        >
            <template #header>
                <div class="flex justify-between card-header border-0 pt-6">
                    <div class="card-title">
                        <div class="my-1">
                            <span class="p-input-icon-left">
                                <i class="pi pi-search"/>
                                <InputText type="text" class="form-control w-[250px] ps-15"
                                    placeholder="Rechercher une catégorie"
                                    v-model="criteria"
                                    @keyup.enter="onFilterDt"
                                    @input="onClearInputFilter"/>
                                </span>
                        </div>
                    </div>
                </div>
            </template>
            <div class="card-body pt-0">
                <Column field="name" header="Catégorie"></Column>
                <Column headerStyle="width: 12em;">
                    <template #header>
                        <div>Action</div>
                    </template>
                    <template #body="slotProps">
                        <router-link :to="{ name: 'categoryProductFiltersManagement', params: { uuid: slotProps.data.uuid }}">
                            <Button
                                type="button"
                                icon="pi pi-eye "
                                title="Voir les filtres de la catégories"
                                class="p-button-success p-button-eye ml-2">
                            </Button>
                        </router-link>
                    </template>
                </Column>
            </div>
            <template #empty>Aucune catégorie trouvé.</template>
        </DataTable>
    </div>
</template>

<script setup lang="ts">
import {ref, onMounted} from "vue";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import Button from "primevue/button";
import InputText from "primevue/inputtext";
import {fetchPaginatedCategories} from "@/_services/category/category";
import {ICategory} from "@/models/category/ICategory";

const loading = ref<boolean>(true);
const categories: ICategory[] = [];
const tableData = ref<Array<ICategory>>(categories);
const currentPage = ref<number>(0);
const rows = ref<number>(10);
const totalRecords = ref<number>(0);
const page = ref<number>(1);
const criteria = ref<string>("");

onMounted(async () => {
    await populateDatatable(rows.value, page.value);
});

const populateDatatable = async (
    itemsPerPage: number,
    page: number,
    criteria?: string,
    sort?: {
        fieldLabel: string;
        fieldValue: string
    }
) => {
    showSpinner();
    const [loadingDt, totalRecordsDt, tableDataDt] = await fetchPaginatedCategories(
        itemsPerPage,
        page,
        null,
        criteria,
        sort
    );

    loading.value = loadingDt.value;
    totalRecords.value = totalRecordsDt.value;
    tableData.value = tableDataDt.value;
};

const onPaginate = async (e: { rows: number; page: number; }) => {
    rows.value = e.rows;
    currentPage.value = e.page;
    page.value = e.page + 1;
    await populateDatatable(e.rows, e.page + 1, criteria.value);
};

const onFilterDt = () => {
    if (criteria.value != "") {
        populateDatatable(rows.value, page.value, criteria.value);
    }
};

const onClearInputFilter = () => {
    if (criteria.value === "") {
        populateDatatable(rows.value, page.value);
    }
};

const showSpinner = () => {
    loading.value = true;
}

const hideSpinner = () => {
    loading.value = false;
}
</script>
